<template>
  <div>
    <v-dialog v-model="value" persistent max-width="800">
      <v-card>
        <div class="text-xs-right">
          <v-btn small flat fab @click="onCancel" :loading="loading">
            <v-icon>close</v-icon>
          </v-btn>
        </div>
        <v-card-text>
          <v-text-field
            label="Broadcast name"
            data-vv-as="Broadcast name"
            v-validate="`required`"
            name="broadcast_name"
            :hide-details="!errors.has('broadcast_name')"
            :error-messages="errors.has('broadcast_name') ? errors.first('broadcast_name') : ''"
            v-model="name"
            outline
          ></v-text-field>
        </v-card-text>
        <v-divider />
        <v-card-text>
          <div class="title mb-3">Target Customize</div>
          <v-layout wrap>
            <v-flex xs12 sm6 class="pa-1">
              <v-text-field label="Fullname" v-model="fullname" outline hide-details></v-text-field>
            </v-flex>
            <v-flex xs12 sm6 class="pa-1">
              <v-radio-group v-model="gender" row>
                <v-radio label="All" value=""></v-radio>
                <v-radio label="Male" value="male"></v-radio>
                <v-radio label="Female" value="female"></v-radio>
              </v-radio-group>
            </v-flex>
            <v-flex xs12 sm6 class="pa-1">
              <v-dialog
                ref="datefrom"
                v-model="datefromModal"
                :return-value.sync="datefrom"
                persistent
                lazy
                full-width
                width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    label="First Conversation at"
                    v-model="datefrom"
                    readonly
                    outline
                    hide-details
                    clearable
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker v-model="datefrom" scrollable>
                  <v-spacer></v-spacer>
                  <v-btn flat color="primary" @click="datefromModal = false">Cancel</v-btn>
                  <v-btn flat color="primary" @click="$refs.datefrom.save(datefrom)">OK</v-btn>
                </v-date-picker>
              </v-dialog>
            </v-flex>
            <v-flex xs12 sm6 class="pa-1">
              <v-dialog
                ref="dateto"
                v-model="datetoModal"
                :return-value.sync="dateto"
                persistent
                lazy
                full-width
                width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    label="Last Conversation at"
                    v-model="dateto"
                    readonly
                    outline
                    hide-details
                    clearable
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker v-model="dateto" scrollable>
                  <v-spacer></v-spacer>
                  <v-btn flat color="primary" @click="datetoModal = false">Cancel</v-btn>
                  <v-btn flat color="primary" @click="$refs.dateto.save(dateto)">OK</v-btn>
                </v-date-picker>
              </v-dialog>
            </v-flex>

            <v-flex xs12>
              <div class="pa-1">Variables</div>
              <template v-for="(variable, index) in variables">
                <broadcast-variable
                  v-model="variables[index]"
                  :key="`variable_${index}_${timestamp}`"
                  @deleteVariable="deleteVariable(index)"
                ></broadcast-variable>
              </template>
              <br />
              <v-btn color="primary" depressed @click="variables.push('')"
                ><v-icon>add</v-icon> Add Variable</v-btn
              >
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-divider />
        <v-card-text>
          <div class="title mb-3">Message</div>
          <intent-manage-answers :key="timestamp" v-model="message"></intent-manage-answers>

          <p class="small" style="margin-top: 10px;">{{ $t('Choice') }}</p>

          <div class="form-control" :class="{ 'has-error': errorChoice.length > 0 }">
            <tags
              v-model="choice"
              :tags="choices"
              @tags-changed="addChoices"
              @before-adding-tag="checkChoices"
              style="margin-bottom: 5px;"
              :btnText="$t('Add choice')"
            ></tags>
            <!-- <vue-tags-input v-model="reply" :tags="replies" @tags-changed="newTags => replies = newTags" @before-adding-tag="checkQuickReply" /> -->
            <span class="text-error" v-if="errorChoice.length > 0">
              <template v-if="errorChoice.includes('overmaxlength')">{{
                $t('Message cannot be longer than 20 alphabets')
              }}</template>
              <template v-else-if="errorChoice.includes('overtagmax')">{{
                $t('Choices cannot be more than 10 items')
              }}</template>
              <template v-else-if="errorChoice.includes('duplicate')">{{
                $t('Duplicate Choice')
              }}</template>
            </span>
          </div>
          <input
            type="hidden"
            v-validate="'min_value:1'"
            :name="'messages'"
            v-model="message[0].length"
            :data-vv-as="$t('Broadcast Messages')"
          />
          <div class="form-control mt-4" :class="{ 'has-error': errors.has('messages') }">
            <span class="text-error" v-show="errors.has('messages')">{{
              errors.first('messages')
            }}</span>
          </div>
        </v-card-text>
        <v-divider />
        <v-card-text>
          <v-layout>
            <v-flex><div class="title mt-3">Schedule</div></v-flex>
            <v-flex shrink class="text-xs-right">
              <v-switch v-model="isschedule" :label="'Turn on/off schedule'"></v-switch>
            </v-flex>
          </v-layout>
          <v-layout wrap v-if="isschedule">
            <v-flex xs6 class="pa-1">
              <v-dialog
                ref="scheduledate"
                v-model="scheduledateModal"
                :return-value.sync="scheduledate"
                persistent
                lazy
                full-width
                width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    label="Schedule Date"
                    v-model="scheduledate"
                    readonly
                    outline
                    v-validate="'required'"
                    data-vv-as="Date"
                    name="scheduledate"
                    :hide-details="!errors.has('scheduledate')"
                    :error-messages="errors.has('scheduledate') ? errors.first('scheduledate') : ''"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker :min="today" v-model="scheduledate" scrollable>
                  <v-spacer></v-spacer>
                  <v-btn flat color="primary" @click="scheduledateModal = false">Cancel</v-btn>
                  <v-btn flat color="primary" @click="$refs.scheduledate.save(scheduledate)"
                    >OK</v-btn
                  >
                </v-date-picker>
              </v-dialog>
            </v-flex>
            <v-flex xs6 class="pa-1">
              <v-dialog
                ref="scheduletime"
                v-model="scheduletimeModal"
                :return-value.sync="scheduletime"
                persistent
                lazy
                full-width
                width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    label="Time"
                    v-model="scheduletime"
                    readonly
                    outline
                    v-validate="'required'"
                    data-vv-as="Time"
                    name="scheduletime"
                    :hide-details="!errors.has('scheduletime')"
                    :error-messages="errors.has('scheduletime') ? errors.first('scheduletime') : ''"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-time-picker
                  :allowed-minutes="allowedStep"
                  v-if="scheduletimeModal"
                  v-model="scheduletime"
                  full-width
                >
                  <v-spacer></v-spacer>
                  <v-btn flat color="primary" @click="scheduletimeModal = false">Cancel</v-btn>
                  <v-btn flat color="primary" @click="$refs.scheduletime.save(scheduletime)"
                    >OK</v-btn
                  >
                </v-time-picker>
              </v-dialog>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-divider />
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat @click="onCancel" :loading="loading">{{ $t('cancel') }}</v-btn>
          <v-btn depressed color="primary" outline @click="onSend(false)" :loading="loading">{{
            $t('Save')
          }}</v-btn>
          <v-btn depressed color="primary" @click="onSend(true)" :loading="loading">{{
            $t('Send')
          }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import api from '@/api'
import Tags from '@/components/elements/Tags'
import moment from 'moment'
import IntentManageAnswers from '@/components/view/flow/IntentManageAnswers'
import { mapGetters, mapMutations } from 'vuex'
import BroadcastVariable from './BroadcastVariable'
export default {
  props: ['value', 'currentbroadcast'],
  data() {
    return {
      gender: '',
      name: '',
      fullname: '',
      datefromModal: false,
      datefrom: null,
      datetoModal: false,
      dateto: null,
      scheduledate: null,
      scheduletime: null,
      scheduledateModal: false,
      scheduletimeModal: false,
      today: moment().format('YYYY-MM-DD'),

      variables: [],
      broadcast: {
        message: '',
        quick_reply: ''
      },
      message: [[]],
      errorChoice: [],
      choice: '',
      loading: false,
      timestamp: moment().format('x'),
      isschedule: false
    }
  },
  components: {
    Tags,
    IntentManageAnswers,
    BroadcastVariable
  },
  mounted() {
    if (this.currentbroadcast) {
      try {
        this.message = JSON.parse(this.currentbroadcast.message)
        var condition = JSON.parse(this.currentbroadcast.condition)
        this.variables = condition.variables ? condition.variables : []
        this.datefrom = condition.datefrom ? condition.datefrom : null
        this.dateto = condition.dateto ? condition.dateto : null
        this.gender = condition.gender ? condition.gender : ''
        this.fullname = condition.fullname ? condition.fullname : ''
        this.name = this.currentbroadcast.name
        this.broadcast.quick_reply = this.currentbroadcast.quick_reply
        this.isschedule = this.currentbroadcast.isschedule
        this.scheduledate = this.currentbroadcast.scheduletime
          ? moment(this.currentbroadcast.scheduletime).format('YYYY-MM-DD')
          : null
        this.scheduletime = this.currentbroadcast.scheduletime
          ? moment(this.currentbroadcast.scheduletime).format('HH:mm')
          : null
        this.timestamp = moment().format('x')
      } catch (error) {}
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    }),
    currentTime() {
      const start = moment()
      const remainder = 5 - (start.minute() % 5)

      return moment(start)
        .add(remainder, 'minutes')
        .format('HH:mm')
    },
    choices: {
      get() {
        let vm = this
        if (vm.broadcast && vm.broadcast.quick_reply && vm.broadcast.quick_reply !== '') {
          // console.log(vm.broadcast.quick_reply)
          var quick_replies = []

          quick_replies = vm.broadcast.quick_reply.split(',')
          var result = []
          $.each(quick_replies, function(index, val) {
            result.push({ text: val })
          })
          return result
        } else {
          return []
        }
      },
      set(value) {
        let vm = this
        var result = []
        $.each(value, function(index, val) {
          result.push(val.text)
        })
        vm.broadcast.quick_reply = result.join(',')
      }
    }
  },
  methods: {
    deleteVariable(index) {
      this.variables.splice(index, 1)
      this.timestamp = moment().format('x')
    },
    allowedStep: m => m % 5 === 0,
    onCancel() {
      this.$emit('input', false)
      this.$emit('onClose')
    },
    addChoices(newTags) {
      this.choices = newTags
    },
    checkChoices(obj) {
      this.errorChoice = []
      if (obj.tag.text.length > 20) {
        this.errorChoice.push('overmaxlength')
        obj.error()
      } else if (this.choices.length >= 10) {
        this.errorChoice.push('overtagmax')
        obj.error()
      } else if (obj.tag.isDuplicate) {
        this.errorChoice.push('duplicate')
        obj.error()
      } else obj.addTag()
    },
    async onSend(flag) {
      var result = await this.$validator.validateAll()
      if (!result) {
        this.goToErrorInput()
        // do stuff if not valid.
        // console.log(this.$validator.errors.items)
        return false
      }

      var result = null
      if (flag) {
        result = await this.$swal.fire({
          title: this.$t('Do you want to send this?'),
          type: 'question',
          showCancelButton: true,
          confirmButtonText: this.$t('Confirm'),
          cancelButtonText: this.$t('cancel'),
          reverseButtons: true
        })
      } else {
        result = await this.$swal.fire({
          title: this.$t('Do you want to save this?'),
          type: 'question',
          showCancelButton: true,
          confirmButtonText: this.$t('Confirm'),
          cancelButtonText: this.$t('cancel'),
          reverseButtons: true
        })
      }

      if (result.value) {
        this.loading = true
        var response = await this.sendBroadcast(flag)
        if (response.data) {
          this.$emit('sent', response.data && response.data.length > 0 ? response.data[0] : null)
        }
        this.$emit('input', false)
        this.$emit('onClose')
        this.loading = false
      }
    },
    async sendBroadcast(sendflag) {
      var data = {
        botorigin: this.selectedBot.pageid,
        name: this.name,
        message: JSON.stringify(this.message),
        quick_reply: this.broadcast.quick_reply,
        condition: {
          fullname: this.fullname,
          timestamp_from: this.datefrom,
          timestamp_to: this.dateto,
          variables: this.variables
        },
        sendflag: sendflag,
        isschedule: this.isschedule,
        scheduletime: this.isschedule ? `${this.scheduledate} ${this.scheduletime}` : null
      }

      if (this.currentbroadcast) data.broadcastid = this.currentbroadcast.id

      var response = await api.sendBroadcast({ data: data, param: {} })
      if (response.responsecode == 200) {
        return Promise.resolve(response)
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/broadcast/AddBroadcast.vue